<template>
    <div v-if="resultList.length" class="parseCard" @touchend.prevent="openParseDetail()" @click.stop="openParseDetail()">
        <div class="parseCard-title">政企专属文档解析 <span class="Beta">Beta</span></div>
        <div v-if="loading" class="parseCard-loading">
            <w-skeleton animation>
                <w-space direction="vertical" :style="{ width: '100%' }" size="large">
                    <w-skeleton-line :rows="10" :line-spacing="8" :line-height="10" :widths="widthArr" />
                </w-space>
            </w-skeleton>
        </div>
        <div v-else-if="!loading&&resultList.length" class="parseCard-content">
            <div class="parseCard-item" v-for="(item, index) in resultList" :key="index">
                <div class="item-icon">
                    <SvgIcon :name="item.icon" size="16" color="var(--active-color)" />
                </div>
                <div class="item-desc">
                    <div class="desc-name">{{ item.name }}</div>
                    <div class="desc-result" v-html="item.desc"></div>
                </div>
            </div>

        </div>
        <div class="defaultResult"></div>
    </div>
</template>
<script lang="ts" setup>
import { computed, ref, onMounted, onUnmounted, nextTick, h, watch, defineCustomElement, onBeforeUnmount, defineAsyncComponent } from 'vue';
import { listDocumentParseResult,listGuestDocumentParseResult } from '/@common/api/index.ts';
import { useChatStore } from '/@/stores/chat';
import { getTicketId} from '/@common/utils/utils.ts';
import { setScrollPosition } from '/@common/utils/other';
import DSBridge from '/@common/utils/dsBridge/dsBridge';
const chatStore = useChatStore();

interface Props {
    id?:string

}
const props = defineProps<Props>();
const loading = ref(false)
const widthArr = ref(['100%', '100%', '70%', '100%', '50%', '100%', '100%', '80%', '100%', '60%'])
const resultList = ref([])
const openParseDetail = () => {
    if (loading.value) {
        return
    }
    if(DSBridge.isDSBridgeEnvironment()){
        DSBridge.callNative('triggerFileParseCard', {fileId:props?.id||''})
        return 
    }else{
        getPareseResult('click')
    }
   
    // chatStore.isShowFileParse = true

}
const getPareseResult=async(type?:string)=>{
//    loading.value=true
let api=getTicketId()?listGuestDocumentParseResult:listDocumentParseResult
   let res=await api(props?.id)
//    loading.value=false
   if(res?.code==200&&res?.data){
    if(res?.data?.length){
        chatStore.fileParseContent=res.data||[]
        if(!type){
            setScrollPosition('.center-side')
        }
    }
    resultList.value=res.data||[]
    if(chatStore.fileParseContent.length&&!chatStore.isShowFileParse&&type){
        chatStore.isShowFileParse=true
    }
   }
}
onMounted(async() => {
    getPareseResult()
})
</script>
<style scoped lang="scss">
.parseCard {
    margin-top: 12px;
    width: 80%;
    max-width: 240px;
    background: #FFFFFF;
    border-radius: 16px;
    padding: 20px 24px;
    cursor: pointer;
    &:hover{
        box-shadow: rgba(38, 42, 50, 0.2) 0px 2px 16px;
    }

    .parseCard-title {
        font-size: var(--font16);
        color: #181B49;
        display: flex;
        align-items: center;

        .Beta {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 32px;
            height: 16px;
            background: #E1E7FF;
            border-radius: 4px 4px 4px 4px;
            font-weight: 500;
            font-size: 10px;
            color: #355EFF;
            margin-left: 6px;

        }
    }

    .parseCard-loading {
        margin-top: 12px;

        :deep(.w-skeleton-line) {
            border-radius: 2px !important;
            background-color: #fff !important;
        }
    }

    .parseCard-content {
        .parseCard-item {
            padding: 12px 0;
            border-bottom: 1px solid #E4E8EE;
            display: flex;
            align-items: center;

            .item-icon {
                width: 40px;
                height: 40px;
                background: rgba(53, 94, 255, 0.06);
                border-radius: 8px;
                display: flex;
                align-items: center;
                justify-content: center;
                margin-right: 8px;
            }

            .item-desc {
                .desc-name {
                    font-size: var(--font14);
                    color: #181B49;
                    line-height: 22px;
                }

                .desc-result {
                    font-size: 12px;
                    color: #9A99AA;

                    :deep(.num) {
                        color: #F33749 !important;
                        padding: 0 2px;
                    }
                }

            }

            &:last-child {
                border-bottom: none;
                padding-bottom: 0;
            }
        }
    }
}
</style>